const merge = require('webpack-merge')

const isProd = (process.env.NODE_ENV == 'production')

const _base_config = {
    //serieses_data_path = '@/series-data'
    // D:\works\108-DeepLearning-Portal\src\series-data
    //serieses_data_path: '/d/works/108-DeepLearning-Portal/src/series-data'
    serieses_data_path: "http://localhost:8080/static/series-data/"
}

let config = _base_config

if (isProd) {
    config = merge(config, require('../config/prod.json'))
}
else {
    config = merge(config, require('../config/dev.json'))
}

// for debug : force Secret and password to use prod in dev env
// is normally, below two lines should be remarked.
//config.Secret = require('../config/prod.json').Secret
//config.JsonEditorPassword = require('../config/prod.json').JsonEditorPassword

//console.log(`*** [config/index.js]`, `isProd : ${isProd}`)
//console.log(`*** [config/index.js]`, `__dirname`, __dirname, 'process.cwd()', process.cwd())
//console.log(`*** [config/index.js]`, `config :`, config)

module.exports = config



// WEBPACK FOOTER //
// ./src/config/index.js